// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"78cec30d","271":"59edb5dc","311":"6cfe21dc","453":"bf715293","511":"6c755fdc","650":"40f9d746"}[chunkId] + ".chunk.js";
};